<template>
  <div class="login container d-flex justify-content-center align-items-center vh-100">
    <div class="card" style="width: 24rem;">
      <div class="card-body">
        <h2 class="text-center mb-4">Login</h2>
        <p class="mt-3 text-center text-muted">
          The authentication is made against faculty servers, so use the same credentials as you apply to login to any computer in FI's computer halls.
        </p>
        <form @submit.prevent="handleLogin" class="needs-validation" novalidate>
          <div class="mb-3">
            <label for="username" class="form-label">Login:</label>
            <input type="text" v-model="username" class="form-control" id="username" placeholder="xlogin" required />
            <div class="invalid-feedback">
              Please enter your login.
            </div>
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">Password:</label>
            <input type="password" v-model="password" class="form-control" id="password" placeholder="password" required />
            <div class="invalid-feedback">
              Please enter your password.
            </div>
          </div>
          <button type="submit" class="btn btn-primary w-100" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="!loading">
              <i class="bi bi-box-arrow-in-right me-2"></i> Login
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>

  <StemAlert />
  <StemErrorModal ref="stemErrorModal"/>
</template>

<script>
import AuthenticationController from '@/controllers/AuthenticationController';
import StemErrorModal from '@/components/StemErrorModal.vue';
import StemAlert from '@/components/StemAlert.vue';

export default {
  name: 'LoginView',
  components: {
    StemAlert,
    StemErrorModal
  },
  data() {
    return {
      username: '',
      password: '',
      loading: false
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      try {
        await AuthenticationController.login(this.username, this.password);
        
        this.$store.commit('hideAlert'); // Hide alert success login
        this.$router.push('/');
      } catch (error) {
        console.log(error);
        console.log(error.message);
        
        this.$store.dispatch('triggerAlert', {
            type: 'error',
            title: 'Login failed',
            message: error.message
          });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>